// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MJD11","icon":"styles_icon__7VgFa"};